import { SkeletonGroup, SkeletonThumbnail } from '@shared/components/Skeleton';
import { withWindow } from '@shared/utils/withWindow';
import React, { useState, useEffect } from 'react';
import { StyledIconWrapper } from './DepartmentIcon.styles';

interface DepartmentIconProps {
  iconPath: Maybe<string>;
}

// Store icon HTML so that we can avoid network requests/showing a skeleton
const IMAGE_URL_BY_PATH: Record<string, string> = {};

const Icon: React.FC<{ iconHtml: string }> = ({ iconHtml }) => {
  return <StyledIconWrapper as="span" size={7} justifyContent="center" dangerouslySetInnerHTML={{ __html: iconHtml }} />;
};

const DepartmentIconSkeleton = () => <SkeletonThumbnail skeletonSize={7} variant="circle" />;

const DepartmentIcon: React.FC<DepartmentIconProps> = React.memo(({ iconPath }) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(() => {
    return IMAGE_URL_BY_PATH[iconPath || ''] ?? undefined;
  });

  useEffect(() => {
    if (iconPath && !IMAGE_URL_BY_PATH[iconPath]) {
      withWindow(global => {
        global.requestIdleCallback(() => {
          fetch(iconPath)
            .then(res => res.text())
            .then(res => {
              IMAGE_URL_BY_PATH[iconPath] = res;
              setImageUrl(res);
            });
        });
      });
    }
  }, [iconPath]);

  return (
    <SkeletonGroup as="span" isReady={!!imageUrl} placeholder={<DepartmentIconSkeleton />}>
      {imageUrl && <Icon iconHtml={imageUrl} />}
    </SkeletonGroup>
  );
});

DepartmentIcon.displayName = 'DepartmentIcon';

export { DepartmentIcon, DepartmentIconSkeleton };
